// Page size requested from GET /companies/carriers/profiles. The backend clamps
// this to its own maximum.
export const CARRIER_SEARCH_PAGE_LIMIT = 20;

export const CARRIER_SEARCH_DEBOUNCE_MS = 500;

export const CARRIER_SEARCH_DROPDOWN_MAX_HEIGHT = 400;

// Width of the input on anything wider than a phone. Wide enough for a full
// carrier name, and the width the results dropdown below it matches.
export const CARRIER_SEARCH_INPUT_WIDTH = "34ch";

/*
Placeholder rows shown while a query is loading. Three is the median number of
carriers a three-character prefix matches in production, which is where the
debounce usually lands a query. Overshooting would be the worse miss: a list
that grows as results arrive reads as loading, while one that collapses reads
as rows being taken away.
*/
export const CARRIER_SEARCH_FIRST_PAGE_SKELETON_ROWS = 3;

export const CARRIER_SEARCH_LOAD_MORE_SKELETON_ROWS = 2;
